"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MirIcon = void 0;
/* eslint-disable max-len */
var react_1 = __importStar(require("react"));
var Icon_1 = require("./Icon");
exports.MirIcon = (0, react_1.forwardRef)(function MirIcon(props, ref) {
    return (react_1.default.createElement(Icon_1.Icon, __assign({ ref: ref, width: "36", height: "24", viewBox: "0 0 36 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.439 16.691H21.2935V7.58984H18.439V16.691Z", fill: "#3CA436" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.4878 16.692L29.4628 13.6107C30.3231 13.296 31.0044 12.6022 31.31 11.7266H22.5166V16.6909H25.3654V13.795H26.7296L28.2255 16.692H31.4878Z", fill: "#3CA436" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.1089 7.58984C22.4924 9.70773 24.3194 11.3131 26.5179 11.3131H31.4264C31.4664 11.1125 31.4879 10.905 31.4879 10.6925C31.4879 8.97905 30.1185 7.58984 28.4295 7.58984H22.1089Z", fill: "#3CA436" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7494 8.7318L11.5565 12.9564H11.352L10.1591 8.7318C9.95702 8.01616 9.31596 7.52344 8.58686 7.52344H5.72705V16.7177H8.59062V11.2848H8.79511L10.4315 16.7177H12.477L14.1134 11.2848H14.3179V16.7177H17.1816V7.52344H14.3216C13.5927 7.52344 12.9515 8.01616 12.7494 8.7318Z", fill: "#3CA436" })));
});
